import type { ReactNode } from "react";
import { forwardRef } from "react";
import * as t from "@rekajs/types";
import type { ComponentType } from "@repo/editor/types";
import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";
import CroppedSection from "../components/common/cropped-section";

export const bannerDefinition: ComponentSettingsProps = {
  backgroundImage: {
    type: "image",
    label: "تصویر پس زمینه",
    default: "/images/banner-worker-protective.png",
  },
  alt: {
    type: "string",
    label: "عنوان تصویر",
    default: "بنر",
  },
  marginTop: {
    type: "style",
    label: "فاصله بالا",
    section: "فواصل",
    default: "-14%",
  },
  marginBottom: {
    type: "style",
    label: "فاصله پایین",
    section: "فواصل",
    default: "-14%",
  },
};

interface BannerProps {
  backgroundImage?: string;
  children: ReactNode;
  marginTop?: string;
  marginBottom?: string;
  alt?: string;
}

export const Banner = forwardRef<HTMLDivElement, BannerProps>((props, ref) => {
  return (
    <div
      className="w-full relative"
      ref={ref}
      style={{
        marginTop:
          props.marginTop || String(bannerDefinition.marginTop.default),
        marginBottom:
          props.marginBottom || String(bannerDefinition.marginBottom.default),
      }}
    >
      <img
        alt={props.alt}
        className="w-full h-full object-cover absolute top-0 bottom-0 left-0 right-0 -z-20"
        onError={(e) => {
          e.currentTarget.src = "/images/placeholder.png";
        }}
        src={
          props.backgroundImage ||
          String(bannerDefinition.backgroundImage.default)
        }
      />
      <div className="w-full relative -scale-[1] -z-10 -top-px">
        <CroppedSection />
      </div>
      <div className="z-10 relative container md:max-w-full lg:max-w-full lg:px-[14%] lg:-my-[calc(13%)]">
        {props.children}
      </div>
      <div className="w-full relative -z-10 -bottom-px">
        <CroppedSection />
      </div>
    </div>
  );
}) as ComponentType<BannerProps>;
Banner.displayName = "Banner";

export const bannerSettings: ComponentSettings = {
  name: "EBanner",
  props: bannerDefinition,
  label: "بنر",
  childrenAllowed: true,
  widgets: {
    label: "بنر",
    template: () =>
      t.componentTemplate({
        component: t.identifier({ name: "EBanner", external: true }),
      }),
  },
};

Banner.componentSettings = bannerSettings;
